import script from "./ErpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ErpPage.vue?vue&type=script&setup=true&lang=js"

import "./ErpPage.vue?vue&type=style&index=0&id=c3a11416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3a11416"]])

export default __exports__